import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.modules.login.resetPassword.title',
    defaultMessage: 'Cambiar contraseña',
  },
  subtitle: {
    id: 'app.modules.login.resetPassword.subtitle',
    defaultMessage:
      'Para mayor seguridad, escribe una contraseña con los siguientes requisitos.',
  },
  passwordLabel: {
    id: 'app.modules.login.resetPassword.password.label',
    defaultMessage: 'Contraseña',
  },
  submit: {
    id: 'app.modules.login.resetPassword.submit',
    defaultMessage: 'Continuar',
  },
  rulesSuccessMessage: {
    id: 'app.modules.login.resetPassword.password.rules.successMessage',
    defaultMessage: '¡Buena elección!',
  },
  rulesErrorResponse: {
    id: 'app.modules.login.resetPassword.password.rules.errorResponse',
    defaultMessage: 'Lo sentimos, tuvimos un problema. Reintenta más tarde.',
  },
  submitSuccessMessage: {
    id: 'app.modules.login.resetPassword.submit.successMessage',
    defaultMessage: '¡Listo! Cambiaste tu contraseña.',
  },
  submitErrorMessage: {
    id: 'app.modules.login.resetPassword.submit.errorMessage',
    defaultMessage:
      'Ocurrió un error y no pudimos cambiar tu contraseña. Vuelve a intentar.',
  },
});
